import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PersonOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"person_off"}/>
}
